<template>
  <div>
    <span v-if="label">
      {{ label }}:
    </span>
    <date-picker
      v-model="timeRange"
      :format="format"
      :type="type"
      :style="{width: width}"
      lang="zh"
      includedEndDate
      range
      confirm
      editable
    />
  </div>
</template>
<script>
import dayjs from 'dayjs'

export default {
  name: 'TimeRangePicker',
  props: {
    start: [Date, String, Object],
    end: [Date, String, Object],
    label: {
      type: String,
      default: '日期',
    },
    format: {
      type: String,
      default: 'YYYY-MM-DD',
    },
    type: {
      type: String,
      default: 'date',
    },
    width: {
      type: String,
      default: '220px',
    },
  },
  data () {
    return {
      timeRange: [],
    }
  },
  watch: {
    // start (val) {
    //   this.timeRange[0] = val
    // },
    // end (val) {
    //   this.timeRange[1] = val
    // },
    timeRange: {
      handler (val) {
        this.$emit('update:start', val[0] ? dayjs(val[0]).format('YYYY-MM-DD') : '')
        this.$emit('update:end', val[1] ? dayjs(val[1]).format('YYYY-MM-DD') : '')
      },
      deep: true,
    },
  },
  mounted () {
    this.timeRange = [this.start, this.end]
  },
}
</script>



// WEBPACK FOOTER //
// src/components/TimeRangePicker.vue